<template>
  <router-view />
</template>
<script>
import { ref, reactive, getCurrentInstance, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { filters, hangeUnit } from '@/utils/index'
import { loginh5, onlineduration } from '@/api/login'
import moment from 'moment'
import { useStore } from 'vuex'
import axios from 'axios'
export default {
  onMounted() {},
  setup(props, context) {
    const store = useStore()
    const state = reactive({
      onnum: 0,
      onduration: '',
    })
    onMounted(() => {
      // checkuser()
      console.log(store.state.timenum)
      if (sessionStorage.getItem('userinfo')) {
        console.log('有userinfo')
      }
    })
    const checkuser = () => {
      if (sessionStorage.getItem('userinfo')) {
        let token = JSON.parse(sessionStorage.getItem('userinfo')).jwtToken
        let config = {
          headers: {
            AizhidaoAuthorizationTokenKey: token,
          },
        }
        axios
          .get(
            'https://web.aimanrenjian.net/qjzx/api/user/my/medal/statistics',
            config
          )
          .then((res) => {
            console.log(res)
            if (res.data.status !== 1) {
              console.log('来计时了')
              sonlineduration()
            } else {
              console.log('没来计时')
            }
          })
      }
    }
    const sonlineduration = () => {
      store.state.timenum = setInterval(() => {
        state.onnum += 1
        setdur(state.onnum)
        console.log(state.onnum)
      }, 60000)
    }
    const setdur = (num) => {
      let parms = {
        dateString: moment().format('YYYY-MM-DD'),
        usedTime: num,
        code: moment().unix(),
        ver: '3',
      }
      onlineduration(parms)
        .then((res) => {
          console.log(res)
          state.onnum = 0
        })
        .catch((err) => {
          state.onnum = 0
        })
    }
    return { state }
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #ffffff;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
